import { removeCookiesByPrefix } from "../cookies";

import { COOKIE_NAMES } from "./cookieNamesMapper";

export function clearHardContentGateCookies() {
  Object.values(COOKIE_NAMES).forEach((getCookieName) => {
    const cookieName = getCookieName();
    if (cookieName) {
      removeCookiesByPrefix(cookieName);
    }
  });
}
